export const hebrewTranslations = {
  locale: 'he',
  direction: 'rtl',
  text: {
    loginStageOneLink: 'השתמש בדומיין מותאם אישית',
    loginStageTwoForgotPassword: 'שכחת ססמא?',
    footerText:
      'זכויות יוצרים © 2005-2023 NICE LTD | inContact, Inc. כל הזכויות שמורות.',
    footerTextLink: 'צור קשר',
    contactCardAddress: 'כתובת',
    contactCardHistory: 'היסטוריית יצירת קשר',
    viewMore: 'ראה עוד',
    assignments: 'משימות',
    accept: 'לְקַבֵּל',
    reject: 'לִדחוֹת',
    markAsResolved: 'סמן כנפתר',
    save: 'לשמור',
    dockControls: 'פקדי עגינה',
    pinControls: 'פקדי פינים',
    addElevation: 'הוסף ערוץ',
    addCommitment: 'הוסף התחייבות',
    hold: 'אחז',
    mute: 'אילם',
    mask: 'מסכה',
    transfer: 'העברה',
    commit: 'לבצע',
    consult: 'התייעץ',
    hungup: 'לנתק',
    record: 'שיא',
    keypad: 'במקלדת',
    contactControls: 'פקדי אנשי קשר',
    goAvailable: 'עבור זמין',
    myProfile: 'הפרופיל שלי',
    favorites: 'מועדפים',
    allCodes: '(שלוש עשרה) כל הקודים',
    logOut: 'להתנתק',
    participantX: 'משתתפים ({x})',
    waitingOnHoldX: 'מחכה בהמתנה ({x})',
    inConsult: '| בהתייעצות',
    Conference: 'וְעִידָה',
    Consult: 'לְהִתְיַעֵץ',
    agentSearchBox: 'חפש אנשים, כישורים',
    available: 'זמין',
    working: 'עובד',
    noAgentFound: 'לא נמצאו סוכנים',
    myTeam: 'הקבוצה שלי',
    appSpace: 'שטח אפליקציות',
    contactCard: 'כרטיס איש קשר',
    schedule: 'לוח זמנים',
    directory: 'מַדרִיך',
    sentiment: 'רֶגֶשׁ',
    enlighten: 'לְהַאִיר',
    wem: 'וום',
    quickReply: 'תשובות מהירות',
    account: 'חֶשְׁבּוֹן',
    home: 'בית',
    assignment: 'מְשִׁימָה',
    queue: 'תוֹר',
    appHealth: 'בריאות האפליקציה',
    settings: 'הגדרות',
    entries: 'כניסות',
    hide: 'להתחבא',
    search: 'לחפש',
    all: 'את כל',
    inbound: 'נכנס',
    outbound: 'יוצא',
    addEdit: 'הוסף / ערוך',
    viewLess: 'צפה פחות',
    addChannel: 'הוסף ערוץ',
    channels: 'ערוצים',
    cellphone: 'טלפון נייד',
    whatsapp: 'וואטסאפ',
    twitter: 'טוויטר',
    minimizePanel: 'צמצם את הלוח',
    newBrowserWindow: 'צור חלון דפדפן חדש',
    rtaActiveTooltipMessage:
      'ניתוח קולו של הפטרון והשוואה להדפסה הקולית הרשומה שלהם.',
    rtaAuthenticatedTooltipMessage:
      'זהותו של הפטרון אומתה בהצלחה באמצעות CXone RTA.',
    rtaNotAuthenticatedTooltipMessage:
      'זהותו של הפטרון לא אומתה באמצעות CXone RTA.',
    rtaMissingPatronIdTooltipMessage: 'תעודת זהות של הפטרון נדרשת עבור RTA.',
    rtaListeningStatus: 'מקשיב לזהות הפטרון',
    rtaDialogTitle: 'הרשמת RTA',
    enroll: 'לְהִרָשֵׁם',
    cancel: 'לְבַטֵל',
    launch: 'לְהַשִׁיק',
    controlPosition: 'עמדת שליטה',
    sms: 'סמס',
    email: 'אימייל',
    addNewChannel: 'הוסף ערוץ חדש',
    outcomes: 'תוצאות',
    allQuickReplies: 'כל התשובות המהירות',
    publicTweet: 'ציוץ ציבורי',
    age: 'גיל',
    timezone: 'אזור זמן',
    companySize: 'גודל החברה',
    replyingTo: 'משיב ל',
    viewDetails: 'הצג פרטים',
    hideDetails: 'הסתר פרטים',
    viewOriginalTweet: 'צפה בציוץ המקורי',
    hideOriginalTweet: 'הסתר ציוץ מקורי',
    viewRepliesTweet: 'צפה בתגובות לציוץ',
    hideRepliesTweet: 'הסתר תגובות לציוץ',
    callRejected: 'שיחה נדחתה',
    digitalInteractionRejected: 'נִדחֶה',
    requestInteraction: 'בקש אינטראקציה',
    newOutbound: 'יוצא חדש',
    requestingInteraction: 'מבקש אינטראקציה',
    quickChatPlaceHolder: 'הזן הודעה כאן',
    conversations: 'שיחות',
    noMatchesFound: 'לא נמצאו תוצאות תואמות',
    addSms: 'הוסף SMS',
    addEmail: 'הוסף אימייל',
    back: 'חזור',
    networkstatus: 'סטטוס רשת',
    agentName: 'שם סוכן',
    agentId: 'זיהוי סוכן',
    stationId: 'מזהה תחנה',
    phoneNumber: 'מספר טלפון',
    callerId: 'שיחה מזוהה',
    currentContacts: 'אנשי קשר נוכחיים',
    browserVersion: 'גרסת דפדפן',
    browserLanguage: 'שפת דפדפן',
    displayedUsername: 'שם משתמש מוצג',
    version: 'גִרְסָה',
    sessionId: 'זיהוי הפעלה',
    agentLegId: 'זיהוי רגל סוכן',
    webServer: 'שרת אינטרנט',
    virtualCluster: 'אשכול וירטואלי',
    browserLocalization: 'לוקליזציה של דפדפן',
    currentTimezone: 'זמן ואזור זמן נוכחיים',
    contactLimit: 'מגבלת יצירת קשר',
    totalLimit: 'גבול מוחלט',
    reqContact: 'בקש איש קשר',
    contactAutoFocus: 'צור קשר עם פוקוס אוטומטי',
    teamName: 'שם קבוצה',
    routing: 'ניתוב',
    enabled: 'מופעל',
    disabled: 'נָכֶה',
    viewOriginalPost: 'צפה בפוסט המקורי',
    hideOriginalPost: 'הסתר את הפוסט המקורי',
    viewRepliesPost: 'צפה בתגובות לפוסט',
    hideRepliesPost: 'הסתר תגובות לפוסט',
    publicComment: 'הערה פומבית',
    next: 'הַבָּא',
    signInHeader: 'היכנס ל-CXone',
    userName: 'שם משתמש',
    password: 'סיסמה',
    backButtonText: 'חזור',
    signInButtonText: 'להתחבר',
    rememberMe: 'זכור אותי',
    voicePreferences: 'העדפות קול',
    rememberPreference: 'זכור העדפה',
    viewAll: 'צפה בהכל',
    favorties: 'מועדפים',
    qReplySent: 'תשובה מהירה נשלחה',
    confirmationNumber: 'מספר אישור',
    allQReplies: 'כל התשובות המהירות',
    replyToPreviousComment: 'זו תשובה לתגובה קודמת',
    loginAndVoicePreference: 'כניסה והעדפות קול',
    avNotifications: 'התראות אָב',
    displayAndAccessability: 'תצוגה ונגישות',
    outBoundCall: 'outBoundCall',
    commitment: 'התחייבות',
    other: 'אחר',
    mySchedule: 'לוח הזמנים שלי',
    week: 'שָׁבוּעַ',
    day: 'יְוֹם',
    today: 'שָׁבוּעַ',
    reports: 'דוחות',
    customIzeToolBar: 'התאמה אישית של סרגל הכלים',
    noAssignedSkills: 'אין כישורים מוקצים',
    noSkillsAssigned: 'לא הוקצו כישורים',
    inQueue: 'בתור',
    agentStates: 'מצבי סוכן',
    contactsInQueue: 'אנשי קשר בתור',
    workItem: 'פריט עבודה',
    greeting: 'היי',
    copilotIntroduction: 'Copilot מספק תובנות ותשובות שמעניקות חוויות יוצאות דופן.',
    howCanIHelp: 'איך אני יכול לעזור?',
    queueCounter: 'מונה תור',
    contactHistory: 'היסטוריית אנשי קשר',
    intents: "כוונות",
    enterIntents: "הזן כוונות",
    enterOutcomes: "הזן תוצאות",
    enterActions: "הזן פעולות",
    enterEntities: "הזן ישויות",
    actions: "פעולות",
    entities: "ישויות",
    customerCard: 'כרטיס לקוח',
    coPilot: "טייס משנה",
    meeting: "פגישה",
    break: "הפסקה",
    shift: 'משמרת',
    activity: 'פעילות',
    add: 'הוסף',
    skill: 'כישור',
    goBack: 'חזור',
    agent: 'סוכן (אני)',
    
    copilotEmailGenerationPlaceholderText: 'Copilot is generating a reply for you.',
    copilotEmailUpdatingPlaceholderText: 'Copilot is updating the reply for you.',
  },
};
